import { LoadingContainer, Breadcrumb, Panels, Bar } from 'peach/components'
import { useParams, useRouteMatch } from 'peach/router'
import { getName } from 'peach/helpers'

import { DynamicForm, Page } from 'core/components'
import { useServicesGet } from 'core/types'

const MonitoringService = () => {
  const { url } = useRouteMatch()
  const { companyId, serviceId } = useParams<{
    companyId?: string
    serviceId?: string
  }>()

  const { data: service, isLoading } = useServicesGet({
    companyId,
    serviceId,
  })

  const title = getName(service) || service?.name || 'Monitoring Service'

  return (
    <Panels header={<Bar title={title} />}>
      <LoadingContainer isLoading={isLoading}>
        <Breadcrumb title={title} to={url} />

        <Page variant='full'>
          <DynamicForm
            data={service || {}}
            fieldEditMode='viewOnly'
            omitFields={['id', 'companyId', 'object']}
          />
        </Page>
      </LoadingContainer>
    </Panels>
  )
}

export default MonitoringService
